// extracted by mini-css-extract-plugin
module.exports = {"assignBtn":"_3KM2zW4M6H51OYvDjbHn17","icon":"_3sZe2Qw9ZjsIPwX9U-c2g9"};